import logo from './logo.svg';
import './App.css';
import React, { useState } from 'react';

import { Layout , Image, Flex, Select, Button, Input, message } from 'antd';
import { Divider, Typography } from 'antd';
import { BrowserRouter as Router, Route, useRoutes, Link, Routes } from 'react-router-dom';


import routes from './routers'; // 导入路由配置

const AppRoutes = () => {
  // 定义路由
  // const routes = [
  //   { path: '/', element: <HomePage /> },
  //   { path: '/about', element: <About /> },
  //   { path: '/contact', element: <Contact /> },
  //   { path: '*', element: <NotFound /> }, // 捕获所有未定义的路径
  // ];

  return useRoutes(routes); // 使用 useRoutes 返回匹配的组件
};

function App() {

  return (
    <AppRoutes></AppRoutes>
  );
}

export default App;
